module.exports = __webpack_public_path__ + "static/arpf-logo-ddbffa3194b1f44e6070c6c4a3ec55c6.png";